'use client';

import { useEffect } from 'react';
import { initDevMetrics } from '../index';

export function useDevMetricsInitializer(application: string, verbose = false) {
  useEffect(() => {
    initDevMetrics(application, verbose);
  }, [application, verbose]);
}
